import { writable } from "svelte/store";

const textStore = writable([{ text: "Webbutvecklare" }]);

export default textStore;
